import React from 'react';

import Urls from '../../../config/index';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Pagination,Row,Col,Input,Select,DatePicker} from 'antd';
import Serach from '../../utils/serach';
import Add from '../../utils/add';
import Edit from '../../utils/edit';
import Head from '../../utils/head';
import moment from 'moment';
import request from '../../utils/request';
import { paramsEncode } from '../../utils/index';
import { connect } from 'react-redux';
const FormItem = Form.Item;
let vpsUrl = Urls.VPSUrl.list;
let modify = Urls.VPSUrl.modify;
let find = Urls.VPSUrl.selectById;
let bulkUpdateUrl = Urls.VPSUrl.bulkUpdateUrl;


//export default class extends React.Component {
class Vps extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            list: [],
            serach: {
                page: 1,
                pageSize: 10
            },
            //deleteData: [],
            status: false
        };
        this.onChange = this.onChange.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
    }

    componentWillMount() {
        this.getList(vpsUrl + paramsEncode(this.state.serach));
        //合作商列表 地区
        (async (url) => {
            try {
                let response = await request(url);
                sessionStorage.setItem("area.options", JSON.stringify(response));
            } catch (e) {
                console.log(e);
                message.error('初始化参数失败');
            }
        })(Urls.PartnerUrl.paramList);
    }

    async getList(url) {
        try {
            let response = await request(url);
            this.setState(Object.assign(this.state, response))
        } catch (e) {
            console.log(e);
            message.error(e);
        }
    }

    confirm(record) {
        let url = Urls.VPSUrl.delete;
        (async (url) => {
            try {
                let response = await request(url, 'delete', record);
                message.success('删除成功');
                this.handleRefresh();//删除完成重新刷新网页
            } catch (e) {
                console.log(e);
                message.error('删除失败');
            }
        })(url);
    }


    onChange(current, pageSize) {
        let _serach = Object.assign(this.state.serach, { page: current, pageSize: pageSize });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(vpsUrl + paramsEncode(this.state.serach));
    }

    serach(serach) {
        //记录搜索文本
        let _serach = Object.assign(this.state.serach, serach, { page: 1 });//page = 1
        this.setState(Object.assign(this.state, { serach: _serach }));
        (async (url) => {
            try {
                let response = await request(url);
                this.state.list = response.list;
                this.setState(Object.assign(this.state, response))
            } catch (e) {
                console.log(e);
                message.error('查询失败');
            }
        })(vpsUrl + paramsEncode(this.state.serach));
    }
    // bulkUpdateVps(){
    //     let ids = this.state.deleteData;
    // }

    handleRefresh() {
        let _serach = Object.assign(this.state.serach, { page: 1 });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(vpsUrl + paramsEncode(this.state.serach));
    }
    onSelectChange = selectedRowKeys => {
         //this.props.deleteGroup(selectedRowKeys);
         this.setState({
            deleteData: selectedRowKeys
         })
    }
    changeAddHide () {
        this.setState({
            status: false
        });
        this.props.form.resetFields();
    }

    async submit () {
        this.setState({
            status: false
        })
        const {deleteData} = this.state;

        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                try {
                    let param = {
                        _id: deleteData,
                        ...fieldsValue,
                    };
                    let result = await request(bulkUpdateUrl, 'POST', param);
                    await this.props.form.resetFields();
                    this.handleRefresh();
                } catch (err) {
                    alert(err);
                }
            } else {
                console.log(err);
            }
        });
        //多选框置为空
        this.setState({
            deleteData: []
         })
        //this.props.form.resetFields(); 修改完表单重置
    };

    bulkUpdate(){
        this.setState({
            status: true
        })         
    }
    render() {

        const rowSelection = {
            selectedRowKeys: this.state.deleteData,
            onChange: this.onSelectChange,
        };
        const formItemLayout = {
            labelCol: {
                xs: { span: 18 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 18 },
                sm: { span: 14 },
            },
        };
        const { getFieldDecorator } = this.props.form;
        const { status } = this.state;

    
        let jsonUaOptions = sessionStorage.getItem('area.options');
        let options = jsonUaOptions ? JSON.parse(jsonUaOptions) : { area: [], partnerName: [] };
        let serachMetas = [{
            type: 'Select',
            placeholder: '合作商',
            field: 'partner',
            options: options.partnerName
        }, {
            type: 'Select',
            placeholder: '地区',
            field: 'area',
            options: options.area
        }, {
            type: 'Select',
            placeholder: '运营商',
            field: 'operator',
            options: ['电信', '联通', '移动']
        }, {
            type: 'Input',
            placeholder: 'IP',
            addonBefore: 'IP',
            field: 'host'
        }];
        let addMetas = [{
            type: 'Select',
            placeholder: '合作商',
            label: '合作商',
            field: 'partner',
            isRequired: true,
            options: options.partnerName
        }, {
            type: 'Select',
            placeholder: '地区',
            label: '地区',
            field: 'area',
            isRequired: false,
            options: options.area
        }, {
            type: 'Select',
            placeholder: '运营商',
            label: '运营商',
            field: 'operator',
            isRequired: true,
            options: ['电信', '联通', '移动']
        }, {
            type: 'Input',
            placeholder: 'IP',
            label: 'IP',
            isRequired: true,
            field: 'host'
        }, {
            type: 'Input',
            placeholder: '端口号',
            label: '端口号',
            isRequired: true,
            field: 'port'
        }, {
            type: 'Input',
            placeholder: '白名单(分隔符:",")',
            label: '白名单',
            isRequired: true,
            field: 'whiteIps'
        }, {
            type: 'Input',
            placeholder: '拨号间隔',
            label: '拨号间隔',
            isRequired: true,
            field: 'intervalTime'
        }, {
            type: 'DatePicker',
            placeholder: '到期时间',
            label: '到期时间',
            isRequired: true,
            field: 'endTime'
        }, {
            type: 'Input',
            placeholder: '备注',
            label: '备注',
            isRequired: true,
            field: 'remark'
        }]


        const columns = [{
            title: '合作商名称',
            dataIndex: 'partner',
            key: 'partner',
        }, {
            title: '地区',
            dataIndex: 'area',
            key: 'area',
        }, {
            title: '运营商',
            dataIndex: 'operator',
            key: 'operator',
        }, {
            title: '机器IP',
            dataIndex: 'host',
            key: 'host',
        }, {
            title: '端口号',
            dataIndex: 'port',
            key: 'port',
        }, {
            title: '到期时间',
            dataIndex: 'endTime',
            key: 'endTime',
            render: (text, record, index) => moment(text).format('YYYY-MM-DD')
        }, {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
        }, {
            title: '操作',
            key: 'action',
            render: record => (
                <span>
                    <Edit metadata={addMetas} url={modify} find={find + '' + record._id} handleRefresh={this.handleRefresh} />
                    <span className="ant-divider" />
                    <Popconfirm title="是否删除?" onConfirm={this.confirm.bind(this, record)}>
                        <a href="#">删除</a>
                    </Popconfirm>
                </span >
            )
        }];
        return (
            <div >
                <h2>VPS列表</h2>
                <Row className="searchRow">
                    <Head serachMeta={serachMetas} addMeta={addMetas} addUrl={modify} handleRefresh={this.handleRefresh} handleSerach={this.serach.bind(this)} />
                </Row>
                <Row className="searchRow">
                    <Button type="primary" onClick={() => this.bulkUpdate()} style={{ margin: '0 8px' }}>批量更新</Button>
                </Row>
                
                <Table columns={columns} dataSource={this.state.list} pagination={false} bordered 
                rowSelection={rowSelection} 
                rowKey="_id" />
                <Pagination
                    showQuickJumper
                    showSizeChanger
                    pageSizeOptions={['10', '30', '50', '100']}
                    current={this.state.serach.page}
                    total={this.state.total}
                    className='ant-table-pagination'
                    onChange={this.onChange}
                    onShowSizeChange={this.onChange}
                />


                <Modal
                    title={'批量修改'}
                    visible={status} //通过改变这个属性的值 来决定是否展示弹窗
                    onCancel={() => this.changeAddHide()}
                    onOk={() => {
                        this.submit();
                    }}>
                    <Form>
                        <FormItem {...formItemLayout} label="合作商">
                            {getFieldDecorator('partner')(
                                <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                    {options.partnerName.map((partName, index) => {
                                        return (
                                            <Option
                                                key={partName}
                                                title={partName}
                                                value={partName}>
                                                {partName}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="地区">
                            {getFieldDecorator('area')(
                                <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                    {options.area.map((areaName, index) => {
                                        return (
                                            <Option
                                                key={areaName}
                                                title={areaName}
                                                value={areaName}>
                                                {areaName}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="运营商">
                            {getFieldDecorator('operator', {
                                initialValue: null,
                            })(<Select>
                                <Option value="电信">电信</Option>
                                <Option value="移动">移动</Option>
                                <Option value="联通">联通</Option>
                            </Select>)}
                        </FormItem>
                        {/* <FormItem {...formItemLayout} label="IP">
                            {getFieldDecorator('host', {
                                initialValue: null,
                            })(<Input placeholder="请填入" />)}
                        </FormItem> */}
                        <FormItem {...formItemLayout} label="端口号">
                            {getFieldDecorator('port', {
                                initialValue: null,
                            })(<Input placeholder="请填入" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="白名单">
                            {getFieldDecorator('whiteIps', {
                                initialValue: null,
                            })(<Input placeholder="请填入" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="拨号间隔">
                            {getFieldDecorator('intervalTime', {
                                initialValue: null,
                            })(<Input placeholder="请填入" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="到期时间">
                                {getFieldDecorator('endTime')(
                                    <DatePicker
                                        //showTime 显示具体时间点的
                                        format="YYYY-MM-DD"
                                        placeholder="选择时间"
                                    />)}
                            </FormItem>
                        <FormItem {...formItemLayout} label="备注">
                            {getFieldDecorator('remark', {
                                initialValue: null,
                            })(<Input placeholder="请填入" />)}
                        </FormItem>
                    </Form>
                </Modal>
            </div>
        );

    }

}

export default connect()(Form.create()(Vps));



// WEBPACK FOOTER //
// ./components/sider/vps.js